<script lang="ts">
	import { setContext, createEventDispatcher, onDestroy } from 'svelte';
	import { writable } from 'svelte/store';
	import { GROUP_CONTEXT } from './group';

	type Value = $$Generic;

	export let multiple = false;
	export let mandatory = false;
	export let values: Value[] = [];

	const dispatch = createEventDispatcher();
	const valueStore = writable(values);

	$: valueStore.set(values);
	$: dispatch('change', values);

	let startIndex = -1;
	setContext(GROUP_CONTEXT, {
		// Function for select and deselect items in a group
		select: (value: Value) => {
			if (multiple) {
				if (values.includes(value)) {
					// Item is in the selection so remove the value from the group
					if (!mandatory || values.length > 1) {
						values.splice(values.indexOf(value), 1);
						values = [...values];
					}
				} else {
					// Add the value to the selection because it's not selected
					values = [...values, value];
				}
			} else if (values.includes(value)) {
				// This must be single select and this item is being removed
				if (!mandatory) {
					values = [];
				}
			} else {
				// This must be a single select and this is the new selected value
				values = [value];
			}
		},
		// Function to update items when the selection state changes
		register: (valuesListener: (values: Value[]) => void) => {
			const unsubscriber = valueStore.subscribe((values) => {
				valuesListener(values);
			});
			onDestroy(unsubscriber);
		},
		// Utility function to give each item a unique id
		nextIndex: () => {
			startIndex += 1;
			return startIndex;
		},
		multiple
	});
</script>

<slot />
